import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, formDataBuilder } from 'services';
import {
  CreateOrderActions as Actions,
  CreateOrderRequestAction as RequestAction,
} from 'store/ducks/orders';

export function* createOrderRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  const formData = formDataBuilder(postData);
  
  try {
    yield call(api.post, `orders`, formData);
    onSuccess && onSuccess();
    notify('success', 'Ordem criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
